import { t } from 'i18next';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import { showErrorAlert } from 'redux/utils';
import {
  toggleFavoriteDiscount,
  getfavoriteDiscountsIds,
  getFavoriteDiscountsData,
} from 'services/favorites';
import {
  TMP_INITIAL_DISCOUNT_LOAD_COUNT,
  TMP_LOAD_MORE_BATCH_SIZE,
} from 'config';

export const fetchFavoritesThunk = createAsyncThunk<
  Awaited<ReturnType<typeof getfavoriteDiscountsIds>>,
  void,
  { rejectValue: string }
>('favorites/fetchFavorites', async (_, { rejectWithValue, dispatch }) => {
  try {
    return await getfavoriteDiscountsIds(dispatch);
  } catch (error) {
    return rejectWithValue('Failed to load favorites');
  }
});

export const fetchFavoriteDiscountsDataThunk = createAsyncThunk<
  {
    data: Awaited<ReturnType<typeof getFavoriteDiscountsData>>['content'];
    page: number;
    hasMore: boolean;
  },
  number,
  { state: RootState; rejectValue: string }
>(
  'favorites/fetchFavoriteDiscountsData',
  async (locationId, { rejectWithValue, dispatch, getState }) => {
    try {
      const state = getState();
      const { isInitialLoad } = state.favorites;

      const size = isInitialLoad
        ? TMP_INITIAL_DISCOUNT_LOAD_COUNT
        : TMP_LOAD_MORE_BATCH_SIZE;
      const page = Math.floor(
        state.favorites.favoriteDiscountsData.length / size,
      );

      const response = await getFavoriteDiscountsData(locationId, page, size);
      return { data: response.content, page, hasMore: !response.last };
    } catch (error) {
      showErrorAlert(
        dispatch,
        error,
        t('alert.ERRORS.favorite_fetch_error.title'),
      );
      return rejectWithValue('Failed to load full favorites');
    }
  },
);

export const toggleFavoriteThunk = createAsyncThunk<
  number,
  { discountId: number; locationId: number },
  { state: RootState; rejectValue: string }
>(
  'favorites/toggleFavorite',
  async ({ discountId, locationId }, { rejectWithValue, dispatch }) => {
    try {
      await toggleFavoriteDiscount(discountId, dispatch);
      await dispatch(fetchFavoriteDiscountsDataThunk(locationId));
      return discountId;
    } catch (error) {
      return rejectWithValue('Failed to toggle favorite');
    }
  },
);
